module.exports = __webpack_public_path__ + "img/komitmen.f7b12b6f.png";